export enum PaymentProgramTabs {
    "PreAuth" = 0,
    "Custom" = 1,
    "FullPay" = 2
  }